"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const defaultProps = {
  visible: true,
  mode: 'render'
};
/**
 * This component can hide its children in several ways.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/Visibility-class.html
 */

const Visibility = styled_components_1.default.div.attrs(({
  visible = defaultProps.visible,
  mode = defaultProps.mode,
  children
}) => ({
  children: mode === 'render' && !visible ? undefined : children
}))(({
  visible = defaultProps.visible,
  mode = defaultProps.mode
}) => "\n    visibility: ".concat(mode === 'visibility' && !visible ? 'hidden' : undefined, ";\n    display: ").concat(mode === 'display' && !visible ? 'none' : undefined, ";\n  "));
exports.default = Visibility;